import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-logo-elevenlabs-large.tsx
/**
* icon.24.logo.elevenlabs.large
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTEwLjMyNSAyMS4wMDVoLTMuMzVWM2gzLjM1em02LjcgMGgtMy4zNVYzaDMuMzV6Ii8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=26838-11042
*/
const Icon24LogoElevenlabsLarge = memo(function Icon24LogoElevenlabsLarge(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M10.325 21.005h-3.35V3h3.35zm6.7 0h-3.35V3h3.35z"
		})
	});
});
//#endregion
export { Icon24LogoElevenlabsLarge };

//# sourceMappingURL=icon-24-logo-elevenlabs-large.js.map